import { observer } from 'mobx-react'
import Footer from '../../../Footer'
import Intro from '../Intro'
import Friendly from '../Friendly'
import Team from '../Team'
import WhoWe from '../WhoWe'
import Solutions from '../Solutions'
import Terminals from '../Terminals'
import Lines from '../Lines'
import VisitCard from '../VisitCard'
import KeyMarkets from '../KeyMarkets'
import NPGroup from '../NPGroup'
import Cooperations from '../Cooperations'
import Conferences from '../Conferences'

const FullPage = observer(() => {
  return (
    <>
      <VisitCard />
      <NPGroup />
      <WhoWe />
      <Intro />
      <Solutions />
      <Terminals />
      <KeyMarkets />
      
      <Conferences />

      <Friendly />
      <Cooperations />

      <Lines />
      <Team />
      <Footer />
    </>
  )
})

export default FullPage
